import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { FolioFisico, QrCargaMensaje } from "./folioFisico";
import { setState, state } from "app/resources/globals";
import { MetodoCargaDescarga } from "app/models/requireme";

export interface Props {
    idCargaDescarga: number;
}
const permisos = resources.User.PermisoRx;
const permisoPermiteTeclear = permisos.map(x => x.CargaDescargaRuta.TeclearFolioEnCargaDescarga);

export class Lector extends React.PureComponent<Props> {
    idCargaDescarga = (props: Props) => props.idCargaDescarga;
    resumen = createSelectorRx(this.idCargaDescarga, id => observeResource(resources.CargaDescarga.ObtenerResumen, id));
    dto = createSelectorRx(this.idCargaDescarga, id => observeResource(resources.CargaDescarga.GetCargaDescarga, id));
    ultimoEscaneoGlobal = (props: Props) => state.map(x => x.ultimaLecturaCargaDescargaRuta);
    ultimoEscaneo = createSelectorRx(this.ultimoEscaneoGlobal, this.idCargaDescarga, (ultimoEscaneo, id) => ultimoEscaneo && (
        ultimoEscaneo.idCargaDescarga == id ? ultimoEscaneo.lectura : null
    ));



    mensaje = createSelectorRx(this.resumen, this.dto, this.ultimoEscaneo, (resumen, dto, ultimoEscaneo) => ({
        camion: dto.NombreCaja,
        cantGuias: resumen.CantidadGuias,
        cantServiciosIncompletos: resumen.CantidadServiciosIncompletos,
        ruta: "TODO",
        ultimoEscaneo: ultimoEscaneo ? {
            guia: ultimoEscaneo.FolioGuia,
            numeroFisico: ultimoEscaneo.NumeroFisico,
            totalNumerosFisicos: ultimoEscaneo.TotalNumerosFisicos,
            tipo: ultimoEscaneo.Tipo == models.TipoFolioFisico.Paquete ? "paquete" : "sobre"
        } : null
    } as QrCargaMensaje));

    finalizado = createSelectorRx(this.dto, dto => dto.Status == models.StatusCargaDescarga.Terminado);


    handleOnLectura = async (x: string, metodo: MetodoCargaDescarga) => {
        const lectura = await resources.CargaDescarga.EscanearFolio(x, this.props.idCargaDescarga, metodo);

        //Notificamos a la aplicación de la ultima carga/descarga
        setState({
            ultimaLecturaCargaDescargaRuta: {
                idCargaDescarga: this.props.idCargaDescarga,
                lectura: lectura
            }
        });
    }

    render() {
        const terminado = this.finalizado(this.props);
        return (
            <div>
                {kea.autogrid(4, [
                    <FolioFisico
                        onLectura={this.handleOnLectura}
                        mensaje={this.mensaje(this.props)}
                        finalizado={terminado}
                        permiteTeclear={permisoPermiteTeclear}
                    />
                ])}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/edit/lector/index.tsx